export default __webpack_public_path__ + "static/media/Shared-Image-ARTIGOS-SYS-07.b31225b2.png";